import { createContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import useAuth from '@frolight/hooks/useAuth';
import useAuthenticatedAPIServiceCall from '@frolight/hooks/useAuthenticatedAPIServiceCall';

import { getPreferences } from '@frolight/services/api/userService';

const defautlUserPreferences = {
  temperatureUnit: 'celsius',
  locale: null
};

const UserPreferencesContext = createContext(defautlUserPreferences);

export const UserPreferencesProvider = ({ children }) => {
  const { auth } = useAuth();
  const authenticatedAPIServiceCall = useAuthenticatedAPIServiceCall();

  const [ userPreferences, setUserPreferences ] = useState(defautlUserPreferences);

  useEffect(() => {
    let mounted = true;
    const abortController = new AbortController();

    const getUserPreferences = async () => {
      try {
        const storedPrefs = await authenticatedAPIServiceCall(getPreferences, {
          abortController: abortController
        });
        
        if (storedPrefs) {
          setUserPreferences({
            temperatureUnit: storedPrefs.temperatureUnit || 'celsius',
            locale: storedPrefs.locale || null
          });
        }
      } catch (err) {
        console.error('Error getting preferences:', err);
      }
    };

    if (auth?.accessToken) {
      getUserPreferences();
    } else {
      setUserPreferences(defautlUserPreferences);
    }
  
    return () => {
      abortController.abort();
      mounted = false;
    };
  }, [ auth.accessToken ]);
  
  return (
    <UserPreferencesContext.Provider
      value={{ userPreferences, setUserPreferences }}
    >
      { children }
    </UserPreferencesContext.Provider>
  );
};

UserPreferencesProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired
};

export default UserPreferencesContext;
